module.exports = __webpack_public_path__ + "img/jnjbzg.85ac55df.png";